import createIcon from '../../createIcon';

/**
 * @component @name EditLocation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM4LjE0IDIgNSA1LjE0IDUgOUM1IDE0LjI1IDEyIDIyIDEyIDIyQzEyIDIyIDE5IDE0LjI1IDE5IDlDMTkgNS4xNCAxNS44NiAyIDEyIDJaTTEwLjQ0IDEySDlWMTAuNTZMMTIuMzUgNy4yMkwxMy43OCA4LjY1TDEwLjQ0IDEyWk0xNC44OSA3LjU1TDE0LjE5IDguMjVMMTIuNzUgNi44MUwxMy40NSA2LjExQzEzLjYgNS45NiAxMy44NCA1Ljk2IDEzLjk5IDYuMTFMMTQuODkgNy4wMUMxNS4wNCA3LjE2IDE1LjA0IDcuNCAxNC44OSA3LjU1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EditLocation = createIcon('EditLocation', [
  [
    'path',
    {
      d: 'M12 2C8.14 2 5 5.14 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.14 15.86 2 12 2ZM10.44 12H9V10.56L12.35 7.22L13.78 8.65L10.44 12ZM14.89 7.55L14.19 8.25L12.75 6.81L13.45 6.11C13.6 5.96 13.84 5.96 13.99 6.11L14.89 7.01C15.04 7.16 15.04 7.4 14.89 7.55Z',
      key: '3sxovj',
    },
  ],
]);

export default EditLocation;
